module.exports = __webpack_public_path__ + "img/banner.331ebae1.png";